<template>
    <div class="login">
        <Navigation/>
        <v-main>
            <v-container>
                <v-row justify="center" class="my-5">
                    <v-col cols="12" :md="8">
                        <v-card :class="isThemeAja ? 'aja-bg-card' : ''" :style="isThemeAja ? { zIndex: 10 } : {}">
                            <CardTitle text="Identifiez-vous"/>
                            <v-card-text>
                                <v-form
                                    ref="form"
                                    v-on:submit.prevent="login"
                                >
                                    <v-text-field
                                        v-model="email"
                                        label="E-mail"
                                        :rules="[rules.required, rules.email]"
                                        outlined
                                        class="aja-color-primary"
                                    ></v-text-field>

                                    <v-text-field
                                        v-model="password"
                                        label="Mot de passe"
                                        :rules="[rules.required]"
                                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                        :type="showPassword ? 'text' : 'password'"
                                        @click:append="showPassword = !showPassword"
                                        outlined
                                        class="aja-color-primary"
                                    ></v-text-field>

                                    <div class="d-flex justify-center">
                                        <v-checkbox class="aja-color-primary mt-0" label="Se souvenir de moi" dense></v-checkbox>
                                    </div>

                                    <v-row justify="center">
                                        <v-col cols="12" :sm="6" class="text-center">
                                            <v-btn
                                                block
                                                class="aja-btn-primary"
                                                type="submit"
                                                :disabled="loading" 
                                                :loading="loading"
                                            >Se connecter</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                <v-row>
                                    <v-col>
                                        <v-btn
                                            block
                                            text
                                            small
                                            :color="isThemeAja ? 'white' : 'secondary'"
                                            :to="{ name: 'register' }"
                                        >Créer un compte</v-btn>
                                    </v-col>
                                    <v-col>
                                        <v-btn
                                            block
                                            text
                                            small
                                            :color="isThemeAja ? 'white' : 'secondary'"
                                            :to="{ name: 'password-reset' }"
                                        >Mot de passe oublié ?</v-btn>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <my-footer v-if="!isThemeAja"/>
        <div   v-else class="text-center">
            <v-img
                ref="footerImg" 
                :src="require('@/assets/images/aja/Stiv.gif')"
                alt="Stiv"
                contain
                width="100%"
                height="200px"
                style="
                    position: absolute;
                    bottom: 10px;
                    z-index: 1;"
            ></v-img>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        data(){
            return {
                email: '',
                password: '',
                showPassword: false,
                loading: false,
                rules: {
                    required: value => !!value || 'Champ requis',
                    email: value => /.+@.+\..+/.test(value) || 'Format invalide',
                },
            }
        },
        computed: {
            ...mapGetters(['isThemeAja']),
        },
        methods: {
            login: function () {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    const { email, password } = this;
                    this.$store.dispatch('authRequest', { email, password })
                        .then(() => {
                            if (this.$store.getters.getProfile.is_aja) {
                                this.$router.push({name: 'aja-home'})
                            } else {
                                this.$router.push({name: 'home'})
                            }
                        })
                        .catch((err) => {
                            this.loading = false;
                        })
                        .finally(() => this.loading = false)
                }
            }
        }
    }
</script>
